export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_AUTHDATA = 'SET_AUTHDATA'
export const SET_TAGS_LIST = 'SET_TAGS_LIST'
export const SET_MENU_LIST = 'SET_MENU_LIST'
export const CLEAR_MENU_LIST = 'CLEAR_MENU_LIST'
export const UPDATE_MENU_LIST = 'UPDATE_MENU_LIST'
export const CLOSE_PAGE = 'CLOSE_PAGE'
export const SET_CURRENT_PATH = 'SET_CURRENT_PATH'
export const SET_CURRENT_PAGE_NAME = 'SET_CURRENT_PAGE_NAME'
export const PAGE_OPENED_LIST = 'PAGE_OPENED_LIST'
export const INCREATE_TAG = 'INCREATE_TAG'
export const REMOVE_TAG = 'REMOVE_TAG'
export const CLEAR_ALL_TAGS = 'CLEAR_ALL_TAGS'
export const CLEAR_OTHER_TAGS = 'CLEAR_OTHER_TAGS'
export const ADD_OPEN_SUBMENU = 'ADD_OPEN_SUBMENU'
export const CLEAR_OPENDED_SUBMENU = 'CLEAR_OPENDED_SUBMENU'
